import { Component } from 'preact'
import Dropdown from './Dropdown'

class TopicSelector extends Component {
  constructor () {
    super()
    this.state = { visible: false }
    this.hideDropdown = this.hideDropdown.bind(this)
  }

  componentDidMount () {
    document.body.addEventListener('click', this.hideDropdown)
  }

  // handle click outside of the dropdown
  hideDropdown (e) {
    const { target } = e
    if (!target.classList.contains('dropdown-button') && !target.classList.contains('dropdown-caret')) {
      this.setState({ visible: false })
    }
  }

  render (props, state) {
    const Selector = () => <div className='topic-selector-buttons'>
      <button className='btn btn-primary qa-topic-selector-new-article' onClick={() => window.location.assign(props.button.url)}>{props.button.label}</button>
      <button className='btn btn-primary dropdown-button qa-topic-selector-toggle' onClick={() => this.setState({ visible: !state.visible })}>
        <span className='dropdown-caret down' />
      </button>
    </div>

    return <div id='topic-selector'>
      <Selector />
      <Dropdown visible={state.visible} items={props.dropDownItems} />
    </div>
  }
}

export default TopicSelector
